import { render, staticRenderFns } from "./Ativacao.vue?vue&type=template&id=b564b6f8&scoped=true&"
import script from "./Ativacao.vue?vue&type=script&lang=js&"
export * from "./Ativacao.vue?vue&type=script&lang=js&"
import style0 from "./Ativacao.vue?vue&type=style&index=0&id=b564b6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b564b6f8",
  null
  
)

export default component.exports